import { gsap } from 'gsap';

const tabPanel = () => {
  const btnTabs = document.querySelectorAll('.nav-tabs li');
  const tabs = document.querySelectorAll('.tab-content >.tab-pane');

  let activeTab = 0;
  let old;

  function carouselTabs(tabIndex) {

    console.log(tabIndex);
    if (tabIndex != activeTab) {
      old = activeTab;
      activeTab = tabIndex;

      btnTabs[old].classList.remove('active');
      btnTabs[activeTab].classList.add('active');

      tabs[old].classList.remove('active');
      tabs[activeTab].classList.add('active');
    }
  }

  for (let i = 0; i < btnTabs.length; i++) {
    btnTabs[i].index = i;
    btnTabs[i].addEventListener('click', function (e) {
      e.preventDefault();
      carouselTabs(this.index);
      this.classList.add('active');
    });

    if (i === 1) {
      btnTabs[0].classList.add('active');
      tabs[0].classList.add('active');
    }
  }
};

export { tabPanel };
